var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppDispatch } from "../../../../store/hooks";
import { Box, Button, Checkbox, Stack, Typography, useMediaQuery } from "@mui/material";
import { EditableDataGrid } from "../../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { useEffect, useState } from "react";
import { FFRMultipleRemarks, FFRUpdateRemarks } from "../../services/apiCalls";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import { CloseWithoutBorder } from "../../../../assets/images";
import dayjs from "dayjs";
import { InfoIcon } from "../../../../assets/customIcons";
import { showSurface } from "../../../../redux/awaitedSurfacesSlice";
import ConfirmationPopUp from "../../../fieldFailureReports/components/confirmationPopUp";
import { useNavigate } from "react-router-dom";
export var RowSelectionPopup = function (_ref) {
    var _PersonData$data, _rowData$, _rowData$2, _rowData$3;
    var onClose = _ref.onClose, selectedRows = _ref.selectedRows, id = _ref.id;
    var SelectedRowsDataWithParent = selectedRows.map(function (selected) { return _objectSpread({}, selected); });
    var _a = useState(SelectedRowsDataWithParent), rowData = _a[0], setRowData = _a[1];
    console.log("rowwwwDATASLECTED", rowData);
    var _b = useState({
        IsParent: false
    }), columnVisibilityModel = _b[0], setColumnVisibilityModel = _b[1];
    var _c = useState((rowData === null || rowData === void 0 ? void 0 : rowData.filter(function (row) { return (row === null || row === void 0 ? void 0 : row.ActionTaken) === "Accept & group"; })) || []), showParentCheckBox = _c[0], setShowParentCheckBox = _c[1];
    var navigate = useNavigate();
    var PersonData = getLocalStorageItem("USER_PROFILE_DATA");
    var BranchData = getLocalStorageItem("SELECTED_BRANCH");
    var branchId = BranchData === null || BranchData === void 0 ? void 0 : BranchData.OrganizationId;
    var organizationId = BranchData === null || BranchData === void 0 ? void 0 : BranchData.ParentOrganizationId;
    var PersonId = PersonData === null || PersonData === void 0 || (_PersonData$data = PersonData.data) === null || _PersonData$data === void 0 ? void 0 : _PersonData$data.IdentityId;
    var dispatch = useAppDispatch();
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var APIDATA = null;
    if (((_rowData$ = rowData[0]) === null || _rowData$ === void 0 ? void 0 : _rowData$.ActionTaken) === "Accept & group") {
        APIDATA = FFRMultipleRemarks;
    }
    else if (((_rowData$2 = rowData[0]) === null || _rowData$2 === void 0 ? void 0 : _rowData$2.ActionTaken) === "Resend To Dealer") {
        APIDATA = FFRUpdateRemarks;
    }
    else if (((_rowData$3 = rowData[0]) === null || _rowData$3 === void 0 ? void 0 : _rowData$3.ActionTaken) === "Close FFR") {
        APIDATA = FFRUpdateRemarks;
    }
    var handleCheckboxChange = function (selectedRowId) {
        console.log("slectedRow", selectedRowId);
        var updatedRows = rowData.map(function (row) { return _objectSpread(_objectSpread({}, row), {}, {
            IsParent: row.id === selectedRowId ? "1" : "0"
        }); });
        console.log("updatedRow", updatedRows);
        setRowData(updatedRows);
    };
    useEffect(function () {
        var shouldShow = rowData.some(function (row) { return (row === null || row === void 0 ? void 0 : row.ActionTaken) == "Accept & group"; });
        setColumnVisibilityModel(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
            IsParent: shouldShow
        }); });
    }, [rowData]);
    var columns = [{
            type: "singleSelect",
            field: "IsParent",
            headerName: "Parent",
            editable: false,
            minWidth: 80,
            renderCell: function (params) {
                return /*#__PURE__*/ React.createElement(Checkbox, {
                    checked: params.row.IsParent === "1",
                    onChange: function () { return handleCheckboxChange(params.row.id); }
                });
            }
        }, {
            type: "string",
            field: "DocumentName",
            headerName: "FFR no.",
            editable: false,
            minWidth: 180
        }, {
            type: "string",
            field: "ASMRemarks",
            headerName: "ASM remarks",
            editable: true,
            minWidth: 150
        }, {
            type: "string",
            field: "ActionTaken",
            headerName: "Action taken",
            editable: false,
            minWidth: 150
        }];
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: "",
            sx: {
                p: 0,
                pt: 2,
                mb: 9,
                border: 0,
                borderRadius: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    sx: {
                        border: "none"
                    },
                    spacing: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: "",
                            columnSize: 12,
                            justifyContent: "space-between",
                            display: "flex",
                            mx: 2,
                            spacing: 0,
                            alignItems: "center",
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "ads",
                                    value: "Select the FFR to take action",
                                    fontWeight: "bold",
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.IconButton,
                                    label: "",
                                    name: "",
                                    value: null,
                                    columnSize: 2,
                                    children: /*#__PURE__*/ React.createElement("img", {
                                        src: CloseWithoutBorder
                                    }),
                                    onClick: function () {
                                        onClose();
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: "",
                            orientation: "horizontal",
                            setFieldProps: function (fromValues) {
                                return {
                                    type: FormItemTypes.Divider,
                                    sx: {
                                        my: 1
                                    },
                                    hidden: fromValues === null || fromValues === void 0 ? void 0 : fromValues.HistoryExpanded
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: "HistoryExpanded",
                    value: false,
                    summaryProps: {
                        sx: {
                            display: "none"
                        }
                    },
                    summary: [],
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            type: FormItemTypes.Accordian,
                            expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                        };
                    },
                    sx: {
                        border: "none"
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.List,
                            name: "ASMRemarkMobileView",
                            value: rowData,
                            columnSize: 12,
                            sx: {
                                mb: 2,
                                mx: 2
                            },
                            disableCheckboxSelection: true,
                            variant: "compact",
                            columns: [{
                                    field: "DocumentName",
                                    flex: 1,
                                    editable: true,
                                    renderCell: function (_ref2) {
                                        var row = _ref2.row;
                                        var rowSelected = row === null || row === void 0 ? void 0 : row.ActionTaken;
                                        return /*#__PURE__*/ React.createElement(Stack, {
                                            direction: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            px: 1,
                                            py: 1,
                                            spacing: 2,
                                            sx: {
                                                borderBottom: "1px solid #e0e0e0"
                                            }
                                        }, /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Typography, {
                                            fontWeight: "bold",
                                            fontSize: "14px"
                                        }, row === null || row === void 0 ? void 0 : row.DocumentName), /*#__PURE__*/ React.createElement(Typography, {
                                            fontSize: "12px",
                                            color: "text.secondary"
                                        }, dayjs.utc(row === null || row === void 0 ? void 0 : row.DocumentDate).format("DDMMM, YYYY"))));
                                    }
                                }],
                            elements: [showParentCheckBox.length > 0 ? {
                                    type: FormItemTypes.ContainerItem,
                                    name: "",
                                    columnSize: 0,
                                    spacing: 0,
                                    display: "inline",
                                    direction: "row",
                                    elements: [{
                                            type: FormItemTypes.CheckBox,
                                            name: "IsParent",
                                            label: "Parent",
                                            columnSize: 0,
                                            setFormState: function (formValues, currValues, field) {
                                                console.log("formValues", formValues === null || formValues === void 0 ? void 0 : formValues.id);
                                                handleCheckboxChange(formValues === null || formValues === void 0 ? void 0 : formValues.id);
                                                return {};
                                            }
                                        }]
                                } : null, {
                                    type: FormItemTypes.CardComponent,
                                    name: "",
                                    label: "",
                                    columnSize: 12,
                                    sx: {
                                        backgroundColor: "secondary.50",
                                        m: 1,
                                        border: 0
                                    },
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: "",
                                            columnSize: 12,
                                            spacing: 0,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: "ActionTaken",
                                                    label: "Action taken:",
                                                    disabled: true,
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: "medium",
                                                        fontSize: "sm"
                                                    },
                                                    containerProps: {
                                                        display: "flex",
                                                        direction: "row",
                                                        justifyContent: "space-between"
                                                    }
                                                }]
                                        }]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: "",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    mx: 0.1,
                                    columnSize: 12,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: "",
                                            columnSize: 12,
                                            label: "ASMremarks",
                                            variant: "subtitle1"
                                        }, {
                                            type: FormItemTypes.TextInput,
                                            name: "AsmRemarks",
                                            placeholder: "",
                                            multiline: true,
                                            rows: 4,
                                            fullWidth: true,
                                            value: null,
                                            sx: {
                                                mb: 2,
                                                paddingRight: 2
                                            }
                                        }]
                                }],
                            getRowHeight: function () { return "auto"; }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: "",
                            columnSize: 12,
                            mx: 1,
                            elements: [{
                                    type: FormItemTypes.Button,
                                    name: "Save",
                                    columnSize: 12,
                                    children: "Save",
                                    fullWidth: true,
                                    variant: "contained",
                                    setFieldProps: function (formValues, field) {
                                        var _formValues$ASMRemark, _formValues$ASMRemark2;
                                        var sharedAction = formValues === null || formValues === void 0 || (_formValues$ASMRemark = formValues.ASMRemarkMobileView) === null || _formValues$ASMRemark === void 0 || (_formValues$ASMRemark = _formValues$ASMRemark[0]) === null || _formValues$ASMRemark === void 0 ? void 0 : _formValues$ASMRemark.ActionTaken;
                                        if (sharedAction !== "Accept & group") {
                                            return {
                                                disabled: false
                                            };
                                        }
                                        var parentCount = (formValues === null || formValues === void 0 || (_formValues$ASMRemark2 = formValues.ASMRemarkMobileView) === null || _formValues$ASMRemark2 === void 0 || (_formValues$ASMRemark2 = _formValues$ASMRemark2.filter(function (value) { return (value === null || value === void 0 ? void 0 : value.ActionTaken) == "Accept & group" && ((value === null || value === void 0 ? void 0 : value.IsParent) === true || (value === null || value === void 0 ? void 0 : value.IsParent) === "1"); })) === null || _formValues$ASMRemark2 === void 0 ? void 0 : _formValues$ASMRemark2.length) || 0;
                                        return {
                                            disabled: parentCount !== 1
                                        };
                                    },
                                    onClick: function (event, formvalues) { return __awaiter(void 0, void 0, void 0, function () {
                                        var result, _rowData$4, finalPayload, finalPayload;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    console.log("formvalues", formvalues);
                                                    return [4 /*yield*/, dispatch(showSurface({
                                                            type: "Dialog",
                                                            Component: ConfirmationPopUp,
                                                            containerProps: {
                                                                fullWidth: true,
                                                                PaperProps: {
                                                                    sx: {
                                                                        borderRadius: "12px",
                                                                        width: {
                                                                            sm: "350px",
                                                                            md: "450px",
                                                                            lg: "450px"
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            //Passing dynamic props
                                                            componentProps: {
                                                                unsavedChangesMessage: "Are sure you want to submit?",
                                                                changesLostMessage: "Actions taken cannot be undone.",
                                                                confirmButtonLabel: "Submit",
                                                                discardButtonLabel: "Cancel",
                                                                icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                                bgColor: "warning.100",
                                                                hoverbgColor: "warning.100"
                                                            }
                                                        }))];
                                                case 1:
                                                    result = _a.sent();
                                                    if (!result.payload) return [3 /*break*/, 7];
                                                    if (!(APIDATA === FFRUpdateRemarks)) return [3 /*break*/, 4];
                                                    finalPayload = {
                                                        StatusKey: ((_rowData$4 = rowData[0]) === null || _rowData$4 === void 0 ? void 0 : _rowData$4.ActionTaken) === "Resend To Dealer" ? "ResentByASM" : "ClosedByASM",
                                                        OrganizationId: organizationId,
                                                        BranchId: branchId,
                                                        UserId: PersonId || "",
                                                        FFRList: formvalues === null || formvalues === void 0 ? void 0 : formvalues.ASMRemarkMobileView.map(function (row) { return ({
                                                            FieldFailureReportId: row.id || "",
                                                            IsParent: row.IsParent,
                                                            Remark: (row === null || row === void 0 ? void 0 : row.AsmRemarks) || "",
                                                            UserId: PersonId || ""
                                                        }); })
                                                    };
                                                    if (!APIDATA) return [3 /*break*/, 3];
                                                    return [4 /*yield*/, APIDATA({
                                                            request: finalPayload
                                                        })];
                                                case 2:
                                                    _a.sent();
                                                    _a.label = 3;
                                                case 3: return [3 /*break*/, 6];
                                                case 4:
                                                    finalPayload = {
                                                        OrganizationId: organizationId,
                                                        BranchId: branchId,
                                                        UserId: PersonId || "",
                                                        FieldFailureReports: formvalues === null || formvalues === void 0 ? void 0 : formvalues.ASMRemarkMobileView.map(function (row) { return ({
                                                            FieldFailureReportId: row.id || "",
                                                            IsParent: row.IsParent,
                                                            Remark: (row === null || row === void 0 ? void 0 : row.AsmRemarks) || "",
                                                            UserId: PersonId || ""
                                                        }); })
                                                    };
                                                    if (!APIDATA) return [3 /*break*/, 6];
                                                    return [4 /*yield*/, APIDATA({
                                                            request: finalPayload
                                                        })];
                                                case 5:
                                                    _a.sent();
                                                    _a.label = 6;
                                                case 6:
                                                    navigate("/areaFieldReports/ffr");
                                                    return [2 /*return*/, "submit"];
                                                case 7: return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: "",
                                    columnSize: 12,
                                    fullWidth: true,
                                    children: "Cancel",
                                    variant: "contained",
                                    onClick: function () {
                                        onClose();
                                    }
                                }]
                        }]
                }]
        }];
    return lgMode ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: rowData || []
        // onChange={onchange}
        ,
        disableAddRow: true,
        dataGridHeader: "Select the FFR to take action",
        disableDeleteRow: true,
        disableToolbarActions: true,
        isCollapsible: true,
        dataGridProps: {
            columnVisibilityModel: columnVisibilityModel,
            initialState: {
                pinnedColumns: {
                    right: ["status"]
                },
                density: "standard"
            },
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false,
            processRowUpdate: function (newRow, oldRow, params) {
                var updatedRows = rowData.map(function (row) { return row.id === newRow.id ? _objectSpread(_objectSpread({}, row), newRow) : row; });
                setRowData(updatedRows);
                return updatedRows;
            }
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        mt: 2,
        display: "flex",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        sx: {
            marginRight: 2,
            marginBottom: 2
        },
        onClick: function () { return onClose(); }
    }, "Cancel"), /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        color: "primary",
        sx: {
            marginRight: 2,
            marginBottom: 2
        },
        disabled: rowData.some(function (row) { return (row === null || row === void 0 ? void 0 : row.ActionTaken) === "Accept & group"; }) && rowData.filter(function (row) { return (row === null || row === void 0 ? void 0 : row.ActionTaken) === "Accept & group" && ((row === null || row === void 0 ? void 0 : row.IsParent) === true || (row === null || row === void 0 ? void 0 : row.IsParent) === "1"); }).length === 0,
        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, _rowData$5, finalPayload, finalPayload, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: ConfirmationPopUp,
                            containerProps: {
                                fullWidth: true,
                                PaperProps: {
                                    sx: {
                                        borderRadius: "12px",
                                        width: {
                                            sm: "350px",
                                            md: "450px",
                                            lg: "450px"
                                        }
                                    }
                                }
                            },
                            //Passing dynamic props
                            componentProps: {
                                unsavedChangesMessage: "Are sure you want to submit?",
                                changesLostMessage: "Actions taken cannot be undone.",
                                confirmButtonLabel: "Submit",
                                discardButtonLabel: "Cancel",
                                icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                bgColor: "warning.100",
                                hoverbgColor: "warning.100"
                            }
                        }))];
                    case 1:
                        result = _a.sent();
                        if (!result.payload) return [3 /*break*/, 7];
                        if (!(APIDATA === FFRUpdateRemarks)) return [3 /*break*/, 4];
                        finalPayload = {
                            StatusKey: ((_rowData$5 = rowData[0]) === null || _rowData$5 === void 0 ? void 0 : _rowData$5.ActionTaken) === "Resend To Dealer" ? "ResentByASM" : "ClosedByASM",
                            OrganizationId: organizationId,
                            BranchId: branchId,
                            UserId: PersonId || "",
                            FFRList: rowData.map(function (row) { return ({
                                FieldFailureReportId: row.id || "",
                                IsParent: row.IsParent,
                                Remark: (row === null || row === void 0 ? void 0 : row.ASMRemarks) || "",
                                UserId: PersonId || ""
                            }); })
                        };
                        if (!APIDATA) return [3 /*break*/, 3];
                        return [4 /*yield*/, APIDATA({
                                request: finalPayload
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 7];
                    case 4:
                        finalPayload = {
                            OrganizationId: organizationId,
                            BranchId: branchId,
                            UserId: PersonId || "",
                            FieldFailureReports: rowData.map(function (row) { return ({
                                FieldFailureReportId: row.id || "",
                                IsParent: row.IsParent,
                                Remark: row === null || row === void 0 ? void 0 : row.ASMRemarks,
                                UserId: PersonId || ""
                            }); })
                        };
                        if (!APIDATA) return [3 /*break*/, 6];
                        return [4 /*yield*/, APIDATA({
                                request: finalPayload
                            })];
                    case 5:
                        res = _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/, "submit"];
                    case 7: return [2 /*return*/];
                }
            });
        }); }
    }, "Save"))) : /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            spacing: 0,
            p: 0
        }
    });
};
